import { getRequiredQuery } from "./helper"
import { getParam } from "./params"
import { getUsername } from "./tokens"

function createFrom(path: string, target?: string) {
  const popupForm = document.createElement("form")
  popupForm.method = "POST"
  popupForm.action = path

  if (target) {
    popupForm.target = target
  }

  const username = getUsername() || ""
  const usernameInp = document.createElement("input")
  usernameInp.name = "username"
  usernameInp.value = username

  const ticket = getParam("ticket", "")
  const ticketInp = document.createElement("input")
  ticketInp.name = "ticket"
  ticketInp.value = ticket

  popupForm.appendChild(usernameInp)
  popupForm.appendChild(ticketInp)
  document.body.appendChild(popupForm)

  return popupForm
}

function postOpen(path: string, popupId: string, popupOptions: string) {
  const popupForm = createFrom(path, popupId)

  const opnner = window.open("about:blank", popupId, popupOptions)

  popupForm.submit()

  if (!("remove" in Element.prototype)) {
    ;(Element.prototype as any).remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this)
      }
    }
  }

  popupForm.remove()

  return opnner
}

function getOpen(path: string, popupId: string, popupOptions: string) {
  return window.open(`${path}${getRequiredQuery()}`, popupId, popupOptions)
}

function open(path: string, popupId: string, popupOptions: string) {
  if (process.env.NODE_ENV === "production") {
    return postOpen(path, popupId, popupOptions)
  }

  return getOpen(path, popupId, popupOptions)
}

function redirect(path: string) {
  if (process.env.NODE_ENV === "production") {
    return createFrom(path).submit()
  }
  return (window.location.href = `${path}${getRequiredQuery()}`)
}

export { open, redirect }
